import { useState, useEffect } from "react";

import { Loader } from "components/loader/Loader";
import InfoIconTooltip from "components/tooltip/InfoIconTooltip";
import { PrimaryButton } from "components/button/Button";
import { Input } from "components/input/Input";
import { captureEvent } from "components/posthog/customEventCapture";
import ThreadList from "views/inbox/components/ThreadList";
import { useRootStore } from "store";

import "../Threads.scss";

export default function MyThreads() {
  const {
    myThreads,
    myTotalThreads,
    isLoadingThreads,
    resetThreads,
    fetchThreads,
    fetchMoreThreads
  } = useRootStore((state) => state.inbox);
  const workingCustomerId = useRootStore(
    (state) => state.global.workingCustomerId
  );
  const [shouldScroll, setShouldScroll] = useState(false);
  const myThreadsSorted = myThreads.sort((a, b) => {
    return new Date(b.lastMessage.createdAt) > new Date(a.lastMessage.createdAt)
      ? -1
      : 1;
  });
  const [searchTerms, setSearchTerms] = useState("");
  const threadsLeftToLoad = myTotalThreads - myThreadsSorted.length;

  const handleOnClearSearch = () => {
    resetThreads();
    fetchThreads(workingCustomerId, false, 0);
  };

  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      getSearchedThreads();
    }
  };

  const getSearchedThreads = () => {
    resetThreads();
    fetchThreads(workingCustomerId, false, 0, searchTerms);
  };

  useEffect(() => {
    if (!workingCustomerId) {
      return;
    }
    resetThreads();
    fetchThreads(workingCustomerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workingCustomerId]);

  return (
    <>
      <div className="mb-6 inboxHeaderWrapper">
        <div>
          <h1 className="m-0 d-flex align-items-center">
            Mina konversationer
            <InfoIconTooltip
              className="ml-3"
              text="Här kan du läsa dina konversationer sorterade efter senaste händelse. Klicka på en av konversationerna för att läsa alla meddelanden och hämta eventuellt bifogade filer. Vill du svara på ett meddelande i en konversation klickar du på Svara och alla i konversationen får ta del av ditt svar. Du kan lägga till personer i en befintlig konversation, men du kan inte ta bort personer från en befintlig konversation. När du har skickat ett meddelande i en konversation, hittar du det skickade meddelandet under Skickat."
            />
          </h1>
          <hr className={"header-border"} />
        </div>
        <div className="searchBox d-flex w-100 ">
          <div className="searchInputBox  d-flex p-3">
            <Input
              className="searchInput mb-0 mr-4 p-4"
              type="text"
              placeholder="Sök efter titel eller innehåll"
              onChange={(e) => setSearchTerms(e.target.value)}
              onKeyUp={(e) => handleKeyUp(e)}
              value={searchTerms}
            />
            <button
              type="reset"
              hidden={searchTerms === ""}
              className="cancelSearchButton"
              onClick={() => {
                setSearchTerms("");
                handleOnClearSearch();
                captureEvent("reset");
              }}
            >
              &times;
            </button>
          </div>
          <PrimaryButton
            onClick={() => getSearchedThreads()}
            disabled={searchTerms.length === 0}
          >
            Sök
          </PrimaryButton>
        </div>
      </div>
      {isLoadingThreads && (
        <div className={"d-flex align-items-center justify-content-center"}>
          <Loader className={"mr-3"} /> Laddar konversationer...
        </div>
      )}
      {!isLoadingThreads && (
        <ThreadList
          threads={myThreadsSorted}
          threadsLeftToLoad={threadsLeftToLoad}
          shouldScroll={shouldScroll}
          loadMore={() => {
            fetchMoreThreads(workingCustomerId, false, myThreadsSorted.length);
            setShouldScroll(true);
          }}
        />
      )}
    </>
  );
}
